import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { setElementTheme } from '../components/slds-system';
import { SldsBaseElement } from '../components/slds-base-element.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import store, { resetStateField, addNotification } from '../src/store';
import { fetchProfile, fetchProfileTab } from '../src/apiActions';
import {repeat} from 'lit/directives/repeat.js';

@customElement('profile-view')
class ProfileView extends connect(store)(SldsBaseElement) {
  @property({ type: Object })
  user = null;

  @property({ type: Object })
  otherUser = null;

  @property({ type: String })
  selectedTab = 'posts';

  @property({ type: Boolean })
  profileDropdownOpen = false;

  @property({ type: Array })
  profileDropdown = [
    {label:'Block User', value: 'block'},
    {label:'Report User', value: 'report'},
  ];

  @property({ type: String })
  activeRoute = '';

  @property({ type: Array })
  posts = [];

  @property({ type: Array })
  comments = [];

  @property({ type: Array })
  categories = [];

  @property({ type: Boolean })
  loading = true;

  @property({ type: Boolean })
  requestPending = false;

  @property({ type: Boolean })
  noMoreResults = false;

  @property({ type: Array })
  stencils = [1,2,3,4,5,6,7];

  @property({type: String}) 
  theme = '';

  @property({type: Object})
  profileTab = null;

  @property({type: Array})
  favoritePosts = [];

  @property({type: Array})
  upvotedPosts = [];

  @property({type: String})
  nextPage = null;

  @property({type: Object})
  postObj = null;

  @property({type: String}) 
  postOpen = '';

  @property({type: Boolean}) 
  isOtherUser = false;

  @property({type: Object}) 
  otherUserMode = null;

  stateChanged(state) {
    if (state.user && !this.isOtherUser && (this.otherUserMode || this.otherUserMode === false)) {
      this.user = state.user;
      if (this.otherUserMode === false) {
        store.dispatch(fetchProfile(this.user.username));
        this.otherUserMode = {username: this.user.username};
      }
    }
    this.otherUser = state.otherUser;
    this.theme = state.theme;
    if (this.otherUser) {
      this.user = this.otherUser;
      store.dispatch(resetStateField('otherUser'));
      this.requestPending = false;
    }
    if (state.nextPageEvent && this.nextPage) {
      if (!this.requestPending && !this.noMoreResults) {
        this.requestPending = true;
        store.dispatch(fetchProfileTab(this.selectedTab, (!this.otherUser) ? this.user.username : this.otherUser.username, this.nextPage));
        this.nextPage = null;
      }
      store.dispatch(resetStateField('nextPageEvent'));
    }
    if (state.profileTab) {
      this.loading = false;
      this.requestPending = false;
      var perPage = 20;
      if (state.profileTab.perPage) {
        perPage = state.profileTab.perPage;
      }
      if (state.profileTab.tab === 'posts') {
        this.posts = [...this.posts, ...state.profileTab.posts.map(post => {
          post.created = new Date(post.created);
          return post;
        })];
        if (state.profileTab.posts.length < perPage) { this.noMoreResults = true; }
      } else if (state.profileTab.tab === 'comments') {
        if (state.profileTab.comments.length < perPage) { this.noMoreResults = true; }
        this.comments = [...this.comments, ...state.profileTab.comments];
      } else if (state.profileTab.tab === 'saved') {
        if (state.profileTab.favoritePosts.length < perPage) { this.noMoreResults = true; }
        this.favoritePosts = [...this.favoritePosts, ...state.profileTab.favoritePosts];
      } else if (state.profileTab.tab === 'upvotes') {
        if (state.profileTab.upvotedPosts.length < perPage) { this.noMoreResults = true; }
        this.upvotedPosts = [...this.upvotedPosts, ...state.profileTab.upvotedPosts];
      }
      this.profileTab = state.profileTab;
      this.nextPage = this.profileTab.nextPage;
      store.dispatch(resetStateField('profileTab'));
    }
    if (this.theme && this.shadowRoot.getElementById('profile-view')) {
      setElementTheme(this.shadowRoot.getElementById('profile-view'), this.theme);
    }
  }

  firstUpdated() {
    super.firstUpdated();
    if (this.theme && this.shadowRoot.getElementById('profile-view')) {
      setElementTheme(this.shadowRoot.getElementById('profile-view'), this.theme);
    }
    this.loadProfile();
  }
  
  updated(changedProperties) {
    if (!this.requestPending && !(this.selectedTab === this.profileTab?.tab) && this.activeRoute === 'profile' && (this.user || this.otherUser)) {
      this.requestPending = true;
      this.loadTab(this.selectedTab);
    }
    if (!this.requestPending && !(this.selectedTab === this.profileTab?.tab) && this.activeRoute === 'profile' && !(this.user || this.otherUser)) {
      this.requestPending = true;
      this.loadProfile(this.selectedTab);
    }
  }

  loadProfile(tab) {
    const urlSegments = window.location.pathname.split('/');
    this.loading = true;
    // Handle /profile paths
    if (urlSegments[1] === 'profile') {
      this.otherUserMode = false;
      return;
    }

    // Handle /user/username paths
    if (urlSegments[1] === 'user') {
      const username = urlSegments[2];
      if (username) {
        store.dispatch(fetchProfile(username));
        this.otherUserMode = {username: username};
        this.isOtherUser = true;
      } else {
        this.otherUserMode = false;
      }
    }

    this.requestUpdate();
  }

  loadTab(tab) {
    console.log("Loading tab: ", tab);
    this.noMoreResults = false;
    this.comments = [];
    this.favoritePosts = [];
    this.upvotedPosts = [];
    this.posts = [];
    if (this.user || this.otherUser) {
      store.dispatch(fetchProfileTab(tab, (!this.otherUser) ? this.user.username : this.otherUser.username));
    }
  }

  static styles = [
    super.styles,
    css`
    :host {
      --background-color2: var(--background-color);
    }
    img {
      min-height: initial;
    }
    .slds-avatar_x-large {
      height: 4rem;
      width: 4rem;
    }
    .profile-container {
      max-width: 60rem;
      margin-left: auto;
      margin-right: auto;
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .slds-tabs--default__item.slds-active, .slds-tabs--default__item.slds-is-active, .slds-tabs_default__item.slds-active, .slds-tabs_default__item.slds-is-active {
      color: var(--text-color);
    }
    .slds-tabs--default__item, .slds-tabs_default__item {
      color: var(--text-color);
    }
    .post {
      height: 28rem;
      background-color: #e5e5e5;
      border-radius: 1rem;
      text-align: center;
      line-height: 18rem;
      font-size: 3rem;
      color: darkgray;
    }
    .dark .post {
      background-color: #514f4d;
    }
    single-post {
      --background-color2: var(--background-color);
      --table-hover2: var(--table-hover);
      --text-color2: var(--text-color);
      --border-color2: var(--border-color);
      --input-text-color2: var(--input-text-color);
    }
  `
  ];

  displayDate(date) {
    return new Date(date).toLocaleDateString();
  }

  selectTab(e) {
    e.preventDefault();
    var target = e.target.closest('a');
    var href = target.href;
    var pathParts = href.split('/');
    var lastPart = pathParts[pathParts.length - 1];
    
    // Get the user id from the current URL path
    var currentPath = window.location.pathname;
    var currentParts = currentPath.split('/');
    var userId = currentParts.includes('user') ? currentParts[currentParts.indexOf('user') + 1] : '';
    this.selectedTab = (lastPart === userId) ? 'posts' : (lastPart === 'profile' ? 'posts' : lastPart);
    // Set href without reloading the page
    var newPath = userId ? 
      `/user/${userId}${lastPart === 'profile' ? '' : (userId===lastPart ? '' : '/' + lastPart)}` :
      `/profile${lastPart === 'profile' ? '' : '/' + lastPart}`;
    history.pushState({}, '', newPath);
  }

  viewPostOpened(e, item) {
    e.preventDefault();
    this.postOpen = item?.url;
    history.pushState({}, null, '/post/' + item?.url);
    this.postObj = item;
  }

  noMoreResultsFunc(tab) {  
    switch(tab) {
      case 'posts':
        return this.posts.length === 0;
      case 'comments':
        return this.comments.length === 0;
      case 'upvotes':
        return this.upvotedPosts.length === 0;
      case 'saved':
        return this.favoritePosts.length === 0;
      default:
        return true;
    }
  }

  viewPostClosed(e) {
    e.preventDefault();
    this.postOpen = '';
    this.postObj = null;
    document.body.style.overflow = "auto";
    // Redirect to /profile
    setTimeout(() => {
      history.pushState({}, null, 'profile');
    });
  }

  dropdownSelect(e) {
    switch(e.detail.type) {
      case 'block':
				store.dispatch(addNotification({
					type: 'success',
					content: {
						heading: 'User blocked',
						// message: 'User blocked'
					}
				}));
        break;
      case 'report':
				store.dispatch(addNotification({
					type: 'success',
					content: {
						heading: 'Post Reported',
						// message: 'Post reported'
					}
				}));
        break;
    }
  }

  render() {
    if (this.otherUser === false) {
      return html`<not-found></not-found>`;
    }
    return html`
    <div class="slds-grid profile-container slds-m-top_large" id="profile-view">
      <div class="slds-col">
        <div class="demo-only slds-size_3-of-4">
          <div class="slds-media slds-media_center">
            <div class="slds-media__figure">
              <span class="slds-avatar slds-avatar_circle slds-avatar_x-large">
                <img alt="${this.user?.display_name}" src="${this.user?.profile_pic}" title="${this.user?.display_name}" />
              </span>
            </div>
            <div class="slds-media__body">
              <h1 class="slds-text-heading_medium">${this.user?.display_name}</h1>
              <p>@${this.user?.username} - ${this.displayDate(this.user?.created)}</p>
            </div>
          </div>
        </div>
        <p class="slds-p-top_small">${this.user?.about || 'My Funny Collection'}</p>
        <div class="slds-tabs_default">
          <ul class="slds-tabs_default__nav" role="tablist">
            <li class="slds-tabs_default__item ${this.selectedTab === 'posts' ? 'slds-is-active' : ''}" title="Posts" role="presentation">
              <a class="slds-tabs_default__link" @click="${this.selectTab}" href="${this.isOtherUser ? '/user/' + this.user?.username : '/profile'}" role="tab" tabindex="0" aria-selected="true" aria-controls="tab-default-1" id="tab-default-1__item">Posts</a>
            </li>
            <li class="slds-tabs_default__item ${this.selectedTab === 'comments' ? 'slds-is-active' : ''}" title="Comments" role="presentation">
              <a class="slds-tabs_default__link" @click="${this.selectTab}" href="${this.isOtherUser ? '/user/' + this.user?.username + '/comments' : '/profile/comments'}" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-2" id="tab-default-2__item">Comments</a>
            </li>
            <li class="slds-tabs_default__item ${this.selectedTab === 'upvotes' ? 'slds-is-active' : ''}" title="Upvotes" role="presentation">
              <a class="slds-tabs_default__link" @click="${this.selectTab}" href="${this.isOtherUser ? '/user/' + this.user?.username + '/upvotes' : '/profile/upvotes'}" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-3" id="tab-default-3__item">Upvotes</a>
            </li>
            <li class="slds-tabs_default__item ${this.selectedTab === 'saved' ? 'slds-is-active' : ''}" title="Saved" role="presentation">
              <a class="slds-tabs_default__link" @click="${this.selectTab}" href="${this.isOtherUser ? '/user/' + this.user?.username + '/saved' : '/profile/saved'}" role="tab" tabindex="-1" aria-selected="false" aria-controls="tab-default-4" id="tab-default-4__item">Saved</a>
            </li>
            <li style="margin-left: auto;" title="Dropdown" role="presentation">
              <slds-dropdown @select="${this.dropdownSelect}" @blur="${() => this.profileDropdownOpen = false}" .open="${this.profileDropdownOpen}" .options="${this.profileDropdown}">
                <button @click="${() => this.profileDropdownOpen = !this.profileDropdownOpen}" class="slds-button slds-builder-header__item-action slds-media slds-media_center slds-text-link_reset slds-p-top_x-small slds-p-bottom_x-small" aria-haspopup="true" aria-expanded="false" title="Click to open menu">
                  <span class="slds-media__body">
                    <span class="slds-icon_container slds-icon-utility-chevrondown slds-current-color">
                      <svg class="slds-icon slds-icon_x-small" aria-hidden="true">
                        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#chevrondown"></use>
                      </svg>
                    </span>
                    <span class="slds-assistive-text">Show More</span>
                  </span>
                </button>
              </slds-dropdown>
            </li>
          </ul>
          ${!this.loading ? html`
          <div id="tab-default-1" class="slds-p-top_large slds-tabs_default__content ${this.selectedTab === 'posts' ? 'slds-show' : 'slds-hide'}" role="tabpanel" aria-labelledby="tab-default-1__item">
            ${this.posts.length === 0 ? html`<div class="slds-text-align_center slds-m-top_x-large slds-m-bottom_large slds-text-heading_medium">No posts</div>` : html``}
            ${repeat(
                this.posts,
                (val) => html`<single-post .categories="${this.categories}" .postOpen='${this.postOpen}' @dialog-opened='${(e) => this.viewPostOpened(e, val)}' .item="${val}"></single-post>`
            )}
          </div>
          <div id="tab-default-2" class="slds-p-top_large slds-tabs_default__content ${this.selectedTab === 'comments' ? 'slds-show' : 'slds-hide'}" role="tabpanel" aria-labelledby="tab-default-2__item">
            ${this.comments.length === 0 ? html`<div class="slds-text-align_center slds-m-top_x-large slds-m-bottom_large slds-text-heading_medium">No comments</div>` : html``}
          ${repeat(
                this.comments,
                (val) => html`<single-comment .item="${val}"></single-comment><hr class="slds-m-top_large slds-m-bottom_large">`
            )}
          </div>
          <div id="tab-default-3" class="slds-p-top_large slds-tabs_default__content ${this.selectedTab === 'upvotes' ? 'slds-show' : 'slds-hide'}" role="tabpanel" aria-labelledby="tab-default-3__item">
            ${this.upvotedPosts.length === 0 ? html`<div class="slds-text-align_center slds-m-top_x-large slds-m-bottom_large slds-text-heading_medium">No upvoted posts</div>` : html``}
            ${repeat(
                this.upvotedPosts,
                (val) => html`<single-post .categories="${this.categories}" .postOpen='${this.postOpen}' @dialog-opened='${(e) => this.viewPostOpened(e, val)}' .item="${val}"></single-post>`
            )}
          </div>
          <div id="tab-default-4" class="slds-p-top_large slds-tabs_default__content ${this.selectedTab === 'saved' ? 'slds-show' : 'slds-hide'}" role="tabpanel" aria-labelledby="tab-default-4__item">
            ${this.favoritePosts.length === 0 ? html`<div class="slds-text-align_center slds-m-top_x-large slds-m-bottom_large slds-text-heading_medium">No saved posts</div>` : html``}
            ${repeat(
                this.favoritePosts,
                (val) => html`<single-post .categories="${this.categories}" .postOpen='${this.postOpen}' @dialog-opened='${(e) => this.viewPostOpened(e, val)}' .item="${val}"></single-post>`
            )}
          </div>
          ` : ``}
          ${this.loading ? repeat(
              this.stencils,
              (index, item) => html`<div class="post slds-m-top_large" style=${`opacity: ${(20-index)/20}`}></div>`
          ) : this.noMoreResults && !this.noMoreResultsFunc(this.selectedTab) ? html`<div class="slds-text-align_center slds-m-bottom_xx-large slds-text-heading_medium">No more results</div>` : html``}
        </div>
      </div>
    </div>
    ${this.postOpen==''?'':html`<view-post .categories="${this.categories}" id='${this.postOpen}' .item='${this.postObj}' @dialog-closed='${(this.viewPostClosed)}'></view-post>`}
    `
  }
}